// Copyright 2023 Amazon.com, Inc. or its affiliates. All Rights Reserved.

import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import "./style.css";
import { CustomColorThemeSpan } from "@components/general/CustomColorTheme/CustomColorTheme";

const BrandedFooter = () => {
    const { t } = useTranslation();

    return (
        <div className="euc-branded-footer-container-style">
            <CustomColorThemeSpan
                additionalClassNames={["euc-branded-footer-span-style"]}
            >
                &copy;{" "}
                {`${moment("01/01/2008").format("YYYY")} - ${moment().format("YYYY")}`}{" "}
                {t("euc.signIn.brandedFooter.awsAffiliates.label")}{" "}
                {t("euc.signIn.brandedFooter.allRightsReserved.label")}
            </CustomColorThemeSpan>
        </div>
    );
};

export default BrandedFooter;
